import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import { Auth } from '@/services/firebase/auth'
import vuetify from '@/plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'
import { defaultLocale, messages } from "@/types/locales"
import VueI18n from "vue-i18n"
import { DB } from "@/services/firebase/db"

const i18n = new VueI18n({
  messages,
  locale: store.getters["global/languageCode"] !== null
    ? store.getters["global/languageCode"].toLowerCase()
    : navigator.language.split('-')[0] || defaultLocale,
  fallbackLocale: defaultLocale
})

Vue.config.productionTip = false

let app: any

const init = () => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: (h) => h(App)
    }).$mount('#app')
  }
}

Auth.onAuthStateChanged(user => {
  if (user && user.emailVerified) {
    DB.collection('users').doc(user.uid).get()
      .then((documentSnapshot) => {
        if (documentSnapshot.exists) {
          const userData = documentSnapshot.data()
          store.commit('account/setUser', {
            id: user.uid,
            email: user.email,
            firstName: userData?.firstName,
            lastName: userData?.lastName,
            isFirstLogin: userData && userData.isFirstLogin !== undefined ? userData.isFirstLogin : true,
            profilePicture: userData?.profilePicture,
            companyLogo: userData?.companyLogo,
            companyColor: userData?.companyColor
          })
        }
      })
  } else {
    store.commit('account/setUser', null)
  }

  init()
})
